// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-d8242f38]{border-bottom:2px solid var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
